import { Link } from "react-router-dom";
import PlaceholderArt from "@/components/PlaceholderArt";
import ProductCover from "@/components/ProductCover";

/**
 * Editorial product card — uses real product cover when available,
 * falls back to the restricted-file placeholder otherwise.
 *
 * Accepts product.images as either ['url', ...] or [{url, alt}, ...].
 */
export default function ProductCard({ product, locked = false }) {
  const priceLabel = product.price ? `$${product.price}` : "—";
  const to = locked ? "/contraband" : `/product/${product.slug}`;
  const hasImages = Array.isArray(product.images) && product.images.length > 0;
  const hero = hasImages ? product.images[0] : null;

  return (
    <Link
      to={to}
      data-testid={`product-card-${product.slug}`}
      className="group block transition-all duration-300"
    >
      <div className="relative ring-1 ring-[#2a1a3a] group-hover:ring-[#ff1493]/60 transition-[box-shadow,outline-color] duration-300 group-hover:shadow-[0_0_28px_rgba(255,20,147,0.18)] overflow-hidden">
        {hero ? (
          <ProductCover image={hero} alt={product.name} locked={locked} />
        ) : (
          <PlaceholderArt
            label={product.placeholder_label || ""}
            sku={product.sku}
            locked={locked}
          />
        )}
      </div>

      <div className="pt-6 pb-2 px-1 flex flex-col gap-2.5">
        <div className="flex items-center justify-between font-mono text-[10px] tracking-[0.24em] uppercase text-[#7a6a90]">
          <span>{product.category}</span>
          {locked ? (
            <span className="text-[#ff3b30]">Restricted</span>
          ) : (
            <span className="text-[#c084fc]">Pre-Drop</span>
          )}
        </div>

        <h3 className="font-display text-lg md:text-xl tracking-tight leading-[1.1]">
          {product.name}
        </h3>

        <div className="mt-1 flex items-baseline justify-between">
          <span className="font-mono text-[13px] tracking-[0.1em] text-white">
            {priceLabel}
            {product.price && <span className="text-[#7a6a90] ml-1.5 text-[10px] tracking-[0.2em]">USD</span>}
          </span>
          <span className="font-mono text-[10px] tracking-[0.24em] uppercase text-[#ff1493] group-hover:text-white transition-colors">
            {locked ? "Authorize →" : "View →"}
          </span>
        </div>
      </div>
    </Link>
  );
}
